export default __webpack_public_path__ + "static/media/add.02d0f49a.svg";